import { DragHandle } from './DragHandle';
import { TableCell, TableRow } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';

export const StaticTableRow: FC<{ row: any }> = ({ row }) => {
  const classes = useStyles();
  return (
    <TableRow className={classes.StyledStaticTableRow} {...row.getRowProps()}>
      {row.cells.map((cell: any, i: number) => {
        if (i === 0) {
          return (
            <TableCell className={classes.StyledStaticData} {...cell.getCellProps()}>
              <DragHandle isDragging />
              <span>{cell.render('Cell')}</span>
            </TableCell>
          );
        }
        return (
          <TableCell className={classes.StyledStaticData} {...cell.getCellProps()}>
            {cell.render('Cell')}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  StyledStaticTableRow: {
    boxShadow: 'rgb(0 0 0 / 10%) 0px 20px 25px -5px, rgb(0 0 0 / 30%) 0px 10px 10px -5px',
    outline: '#005570 solid 1px',

    background: 'white',
  },
  StyledStaticData: {
    outline: 'white solid 1px',
    background: 'white',
    '&:first-of-type': {
      minWidth: '20ch',
    },
  },
}));
